import React from 'react';
import {AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend} from 'recharts';
import {numberFormatted} from "../utils/graph.util";

export default function StackedArea(props) {
  return (
    <div className='shadow-lg p-1 p-4 bg-white dark:bg-gray-800'>
      <ResponsiveContainer width="100%"
                           height={300}>
        <AreaChart
          width={500}
          height={400}
          data={props.entities}
          margin={{
            top: 10,
            right: 0,
            left: 30,
            bottom: 0,
          }}
        >
          <CartesianGrid strokeDasharray="3 3"/>
          <XAxis dataKey={props.group_by}/>
          <YAxis tickFormatter={numberFormatted()}/>
          <Legend/>
          {/*<Tooltip/>*/}
          <Tooltip contentStyle={{backgroundColor: "#8884d8", color: "#fff"}} itemStyle={{color: "#fff"}}
                   formatter={numberFormatted()}/>
          {
            props.data_key.map(key => (<Area type="monotone" dataKey={key.key} stackId="1" stroke={key.fill} fill={key.fill}/>))
          }
          {/*<Area type="monotone" dataKey="uv" stackId="1" stroke="#8884d8" fill="#8884d8"/>*/}
          {/*<Area type="monotone" dataKey="pv" stackId="1" stroke="#82ca9d" fill="#82ca9d"/>*/}
          {/*<Area type="monotone" dataKey="amt" stackId="1" stroke="#ffc658" fill="#ffc658"/>*/}
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
